import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Icon, Typography } from "@bookips/sds";
import Link from "next/link";
const ViewAllCard = (param)=>{
    let { href ="/" , onClick , className , label ="브랜드 전체보기"  } = param;
    return /*#__PURE__*/ _jsxs(Link, {
        href: href,
        onClick: onClick,
        className: cn("flex flex-col items-center justify-center gap-4", "w-[285px] bg-gray-50 rounded-md shrink-0", "max-sm:w-[200px]", "hover:bg-gray-100 transition-colors", className),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-center p-3 rounded-full w-12 h-12 bg-gray-700 max-sm:w-8 max-sm:h-8",
                children: /*#__PURE__*/ _jsx(Icon.ArrowRight_2px, {
                    size: "lg",
                    className: "text-white w-6 h-6 max-sm:w-5 max-sm:h-5 shrink-0"
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle1",
                className: "text-primary max-sm:typo-subtitle2",
                children: label
            })
        ]
    });
};
export default ViewAllCard;
